package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.Cog_play_outline: ImageVector
    get() {
        if (_cog_play_outline != null) {
            return _cog_play_outline!!
        }
        _cog_play_outline = Builder(name = "Cog_play_outline", defaultWidth = 24.0.dp, defaultHeight
                = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(13.54f, 22.0f)
                horizontalLineTo(10.0f)
                curveTo(9.75f, 22.0f, 9.54f, 21.82f, 9.5f, 21.58f)
                lineTo(9.13f, 18.93f)
                curveTo(8.5f, 18.68f, 7.96f, 18.34f, 7.44f, 17.94f)
                lineTo(4.95f, 18.95f)
                curveTo(4.73f, 19.03f, 4.46f, 18.95f, 4.34f, 18.73f)
                lineTo(2.34f, 15.27f)
                curveTo(2.21f, 15.05f, 2.27f, 14.78f, 2.46f, 14.63f)
                lineTo(4.57f, 12.97f)
                lineTo(4.5f, 12.0f)
                lineTo(4.57f, 11.0f)
                lineTo(2.46f, 9.37f)
                curveTo(2.27f, 9.22f, 2.21f, 8.95f, 2.34f, 8.73f)
                lineTo(4.34f, 5.27f)
                curveTo(4.46f, 5.05f, 4.73f, 4.96f, 4.95f, 5.05f)
                lineTo(7.44f, 6.05f)
                curveTo(7.96f, 5.66f, 8.5f, 5.32f, 9.13f, 5.07f)
                lineTo(9.5f, 2.42f)
                curveTo(9.54f, 2.18f, 9.75f, 2.0f, 10.0f, 2.0f)
                horizontalLineTo(14.0f)
                curveTo(14.25f, 2.0f, 14.46f, 2.18f, 14.5f, 2.42f)
                lineTo(14.87f, 5.07f)
                curveTo(15.5f, 5.32f, 16.04f, 5.66f, 16.56f, 6.05f)
                lineTo(19.05f, 5.05f)
                curveTo(19.27f, 4.96f, 19.54f, 5.05f, 19.66f, 5.27f)
                lineTo(21.66f, 8.73f)
                curveTo(21.79f, 8.95f, 21.73f, 9.22f, 21.54f, 9.37f)
                lineTo(19.43f, 11.0f)
                lineTo(19.5f, 12.0f)
                verticalLineTo(12.19f)
                curveTo(19.0f, 12.07f, 18.5f, 12.0f, 18.0f, 12.0f)
                curveTo(17.83f, 12.0f, 17.66f, 12.0f, 17.5f, 12.03f)
                curveTo(17.5f, 11.41f, 17.4f, 10.79f, 17.2f, 10.2f)
                lineTo(19.31f, 8.65f)
                lineTo(18.56f, 7.35f)
                lineTo(16.15f, 8.39f)
                curveTo(15.38f, 7.5f, 14.32f, 6.86f, 13.12f, 6.62f)
                lineTo(12.75f, 4.0f)
                horizontalLineTo(11.25f)
                lineTo(10.88f, 6.61f)
                curveTo(9.68f, 6.86f, 8.62f, 7.5f, 7.85f, 8.39f)
                lineTo(5.44f, 7.35f)
                lineTo(4.69f, 8.65f)
                lineTo(6.8f, 10.2f)
                curveTo(6.4f, 11.37f, 6.4f, 12.64f, 6.8f, 13.8f)
                lineTo(4.68f, 15.36f)
                lineTo(5.43f, 16.66f)
                lineTo(7.86f, 15.62f)
                curveTo(8.63f, 16.5f, 9.68f, 17.14f, 10.87f, 17.38f)
                lineTo(11.24f, 20.0f)
                horizontalLineTo(12.35f)
                curveTo(12.61f, 20.75f, 13.0f, 21.42f, 13.54f, 22.0f)
                moveTo(15.96f, 12.36f)
                curveTo(16.0f, 12.24f, 16.0f, 12.12f, 16.0f, 12.0f)
                curveTo(16.0f, 9.79f, 14.21f, 8.0f, 12.0f, 8.0f)
                reflectiveCurveTo(8.0f, 9.79f, 8.0f, 12.0f)
                reflectiveCurveTo(9.79f, 16.0f, 12.0f, 16.0f)
                curveTo(12.12f, 16.0f, 12.24f, 16.0f, 12.36f, 15.96f)
                curveTo(12.97f, 14.29f, 14.29f, 12.97f, 15.96f, 12.36f)
                moveTo(12.0f, 14.0f)
                curveTo(10.9f, 14.0f, 10.0f, 13.11f, 10.0f, 12.0f)
                reflectiveCurveTo(10.9f, 10.0f, 12.0f, 10.0f)
                reflectiveCurveTo(14.0f, 10.9f, 14.0f, 12.0f)
                reflectiveCurveTo(13.11f, 14.0f, 12.0f, 14.0f)
                moveTo(16.0f, 15.0f)
                verticalLineTo(21.0f)
                lineTo(21.0f, 18.0f)
                lineTo(16.0f, 15.0f)
                close()
            }
        }
        .build()
        return _cog_play_outline!!
    }

private var _cog_play_outline: ImageVector? = null
